import { apiService } from './apiService';

export const bulkSmsService = {
  async send(data: { phones: string[]; message: string; templateId?: string | number; requestId: string }) {
    return apiService.post('/bulk-sms/send', data);
  },

  async getTemplates() {
    return apiService.get('/bulk-sms/templates');
  },

  async createTemplate(data: { name: string; content: string }) {
    return apiService.post('/bulk-sms/templates', data);
  },

  async updateTemplate(id: string | number, data: { name: string; content: string }) {
    return apiService.put(`/bulk-sms/templates/${id}`, data);
  },

  async deleteTemplate(id: string | number) {
    return apiService.delete(`/bulk-sms/templates/${id}`);
  },

  async getLogs(limit = 100) {
    return apiService.get(`/bulk-sms/logs?limit=${limit}`);
  },

  async getUsage() {
    return apiService.get('/bulk-sms/usage');
  },
};
